export type Lang = "en" | "ru";

/** A value provided in every supported language. */
export type Localized<T = string> = Record<Lang, T>;

export const LANGS: Lang[] = ["en", "ru"];
export const STORAGE_KEY = "portfolio-lang";

function isLang(value: unknown): value is Lang {
  return value === "en" || value === "ru";
}

/**
 * Pick the initial language: a saved manual choice wins, otherwise fall back
 * to the system / browser languages — Russian if any of them is Russian,
 * English for everything else.
 */
export function detectLang(): Lang {
  if (typeof window === "undefined") return "en";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (isLang(saved)) return saved;

  const preferred = navigator.languages ?? [navigator.language];
  return preferred.some((code) => code.toLowerCase().startsWith("ru"))
    ? "ru"
    : "en";
}
